import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PlotCard } from "./PlotCard";
import { plotsList, PlotType } from "../../../data/plot-types";
import { snakeEyesRecord } from "../../../analytics/snake-eyes";
import { useChartManager } from "../../hooks/plots/useCentralViz";
import "./Viz.scss";

function CreateVisualization() {
  const navigate = useNavigate();

  const { plotType, tab, setPlotType, setTab, resetContext } = useChartManager();

  useEffect(() => {
    if (plotType && tab) {
      navigate("/viz/edit");
    }
  }, [plotType, tab]);

  function handlePlotClick(plotType: PlotType) {
    resetContext();
    setPlotType(plotType);
    setTab("setup");
    snakeEyesRecord({
      event: "viz/chart_selected",
      eventParams: { chart: plotType },
    });
  }

  const [isNarrowScreen, setIsNarrowScreen] = useState(window.innerWidth <= 442);

  useEffect(() => {
    const handleResize = () => {
      setIsNarrowScreen(window.innerWidth <= 442);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div>
      <h2 style={{ fontWeight: 600, fontSize: 19, margin: "8px 0" }}>Create Chart</h2>
      <p style={{ marginTop: 0 }}>Choose one of the following chart types to visualize the data in your sheet</p>
      {plotsList.map((plot, index) => (
        <PlotCard
          key={index}
          type={isNarrowScreen && plot.abbreviation ? `${plot.abbreviation} Chart` : `${plot.name} Chart`}
          imageSrc={plot.imgIcon}
          tooltipInfo={plot.tooltipInfo}
          img={plot.img}
          onCardClick={() => handlePlotClick(plot.plotType)}
          description={plot.description}
          dataTestID={plot.plotType}
        />
      ))}
    </div>
  );
}

export default CreateVisualization;
